import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { OrderComponent } from '@app/order/order.component';
import { OrderConfirmationComponent } from '@app/order/components';
import { UserResolver, PatientUserResolver } from '@app/core/resolvers';
import { AuthProtectedGuard, AuthPublicGuard } from '@app/auth/guards';

/**
 * routes
 * @type {({path: string; component: OrderRoutingModule; pathMatch: string} | {path: string; redirectTo: string})[]}
 */
const routes: Routes = [
  {
    path: '',
    component: OrderComponent,
    pathMatch: 'full',
    resolve: { user: UserResolver },
    canActivate: [AuthProtectedGuard],
  },
  {
    path: 'orderconfirmation/:confirmationNo',
    component: OrderConfirmationComponent,
    pathMatch: 'full',
    resolve: { user: UserResolver },
    canActivate: [AuthProtectedGuard],
  },
  {
    path: ':upc',
    component: OrderComponent,
    pathMatch: 'full',
    resolve: { user: UserResolver },
    canActivate: [AuthProtectedGuard],
  },
  {
    path: ':upc/patient/:id',
    component: OrderComponent,
    pathMatch: 'full',
    resolve: { user: PatientUserResolver },
    canActivate: [AuthPublicGuard],
  },
  { path: '**', redirectTo: '' },
];

/**
 * OrderRoutingModule
 */
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OrderRoutingModule {}
